import toCamel from './toCamel';

const getContext = <T = any>(): T | undefined => {
  const contextElement = document.getElementById('context_data');

  if (!contextElement?.textContent) {
    console.warn('No context data found in #context_data element.');
    return undefined;
  }

  try {
    const parsed = JSON.parse(contextElement.textContent);
    const context = toCamel(parsed);
    return context as T;
  } catch (err) {
    console.error('Failed to parse context JSON:', err);
    return undefined;
  }
};

export default getContext;
